export default __webpack_public_path__ + "static/919-3eafc405ba7b1e2a3d586cf039dc94a8.gif";